<ng-container *ngIf="loginPage==false">

    <nav class="navbar navbar-expand-lg" style="background-color: var(--purple); color:var(--white) !important">
        <div class="container-fluid">
            <a class="navbar-brand" href="#">
                <h2>
                    <svg version="1.1" id="Laag_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="35" width="35"
                        viewBox="0 0 300 300" style="enable-background:new 0 0 300 300;" xml:space="preserve">
                        <style type="text/css">
                            .st0 {
                                fill: var(--orange);
                            }
                        </style>
                        <path class="st0"
                            d="M161.1,287.3c-18.3,0.1-30-9.3-30.1-25.6c-0.2-16.3,11.7-26,29.5-26.2l60.5-0.6c-8-41-46.4-140.1-68.5-157.7C128.2,101.8,91.4,204.3,81.2,257c-4.6,22.3-11.3,34-28.7,34.1c-19.1,0.1-26.4-11.7-26.5-25.7C25.7,243.3,38.9,199,56.6,153 c22.1-57.6,57.1-141.1,94.9-141.5c37.4-0.4,74.8,82.4,97.7,139.5c18,45.7,31.9,88.4,32.1,111.1c0.1,14.2-6.2,23.9-25.7,24.1 L161.1,287.3z" />
                    </svg>
                    Monitoring Manager
                </h2>
            </a>

            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <a class="nav-link active" aria-current="page" routerLink="/devices"
                            routerLinkActive="active">Devices</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/scenarios" routerLinkActive="active">Scenarios</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/departments" routerLinkActive="active">Departments</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/users" routerLinkActive="active">Users</a>
                    </li>
                </ul>
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" (click)="logoff()" href="#">Logout</a>
                    </li>
                </ul>
            </div>

        </div>
    </nav>

    <div class="row m-5 justify-content-center">
        <div class="col-md-10">
            <div class="p-5 border bg-light">
                <h3>{{pageTitle}}</h3>
                <div>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>

</ng-container>
<ng-container *ngIf="loginPage">
    <nav class="navbar navbar-expand-lg" style="background-color: var(--purple); color:var(--white) !important">
        <div class="container-fluid">
            <a class="navbar-brand" href="#">
                <h2>
                    <svg version="1.1" id="Laag_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="35" width="35"
                        viewBox="0 0 300 300" style="enable-background:new 0 0 300 300;" xml:space="preserve">
                        <style type="text/css">
                            .st0 {
                                fill: var(--orange);
                            }
                        </style>
                        <path class="st0"
                            d="M161.1,287.3c-18.3,0.1-30-9.3-30.1-25.6c-0.2-16.3,11.7-26,29.5-26.2l60.5-0.6c-8-41-46.4-140.1-68.5-157.7C128.2,101.8,91.4,204.3,81.2,257c-4.6,22.3-11.3,34-28.7,34.1c-19.1,0.1-26.4-11.7-26.5-25.7C25.7,243.3,38.9,199,56.6,153 c22.1-57.6,57.1-141.1,94.9-141.5c37.4-0.4,74.8,82.4,97.7,139.5c18,45.7,31.9,88.4,32.1,111.1c0.1,14.2-6.2,23.9-25.7,24.1 L161.1,287.3z" />
                    </svg>
                    Monitoring Manager
                </h2>
            </a>
        </div>
    </nav>

    <div class="row m-5 justify-content-center">
        <div class="col-md-3">
            <div class="p-5 border bg-light">
                <h3>Login</h3>
                <div>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</ng-container>